/**
 * Считывает bootstrap-данные из DOM-элемента mount-контейнера.
 * Возвращает null, если контейнер не найден или данные некорректны.
 * Зеркалирует readCategoryArticlesBootstrap.
 */
export function readTagArticlesBootstrap() {
    var _a, _b, _c;
    const root = document.getElementById('tag-articles-root');
    if (!root)
        return null;
    const tagId = Number(root.dataset.tagId);
    const initialPage = Number((_a = root.dataset.initialPage) !== null && _a !== void 0 ? _a : '1');
    const pageSize = Number((_b = root.dataset.pageSize) !== null && _b !== void 0 ? _b : '10');
    const apiEndpoint = (_c = root.dataset.apiEndpoint) !== null && _c !== void 0 ? _c : '';
    if (!tagId || !apiEndpoint)
        return null;
    return {
        tagId,
        initialPage: Math.max(1, initialPage),
        pageSize: Math.max(1, pageSize),
        apiEndpoint,
    };
}
